
import React, { useState, useRef, useEffect } from "react";
import Input from "../../../../../Components/Input";
import Dropdown from "../../../../../Components/Dropdown";
import MobileInput from "../../../../../Components/MobileInput";
import editIcon from '../../../../../Assets/Icons/edit.png'
import deleteIcon from '../../../../../Assets/Icons/delete.png';
import filterIcon from '../../../../../Assets/Icons/filter.png'
import leftBtuIcon from '../../../../../Assets/Icons/back.png'
import EmailTemplateListController from "../../../../Controllers/AdminScreens/Configuration/TemplateCenter/EmailTemplateListController";
import ConfigurationAddTemplateModal from "../../../../../Components/Modals/ConfigurationAddTemplateModal";
import { convertGMTToLocal } from "../../../../../Utils/Validation";
import Loader from "../../../../../Components/Loader";
import downArrow from '../../../../../Assets/Icons/chevron-down.png';
import DateInput from "../../../../../Components/DateInput";

const EmailTemplateList = ({ data, loading, error, refreshHandlers, employeeList, empLoading, empError }) => {

  const {
    emailTemplateData,
    handleInputChange,
    filterData,
    setFilterData,
    filterLoading,
    filterError,
    currentPage,
    totalPages,
    handlePageChange,
    visiblePages,
    fetchEmailTemplateFilter,
    resetFilters,
    cancelFilters,
    showFilters,
    toggleFilters,
    filterSelectionError,
    expandedRows,
    toggleExpand,
    setExpandedRows,
  } = EmailTemplateListController(data, loading, error, refreshHandlers);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddNewTemplate = () => {
    setIsModalOpen(true); // Open the modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
    setExpandedRows({});
  };

  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [showToggleMap, setShowToggleMap] = useState({});
  const contentRefs = useRef({});

  useEffect(() => {
    const map = {};
    setTimeout(() => {
      emailTemplateData.forEach((_, index) => {
        const ref = contentRefs.current[index];
        if (ref && ref.scrollHeight > ref.clientHeight) {
          map[index] = true;
        }
      });
      setShowToggleMap(map);
    }, 50); // wait for DOM paint
  }, [emailTemplateData, expandedRows]);

  return (
    <>
      <div className='basic-info-container'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h3 style={styles.categoryHeader}>Email Template</h3>
          <div style={{ display: 'flex', marginBottom: '10px' }}>
            <button className="add-client-button" style={{ paddingLeft: 30, paddingRight: 30, marginRight: '15px' }} onClick={handleAddNewTemplate}>
              Add Template
            </button>
          </div>
        </div>
        <div style={styles.container}>
          <div style={styles.filtersHeader}>
            <button style={styles.filterButton} onClick={toggleFilters}> <img src={filterIcon} style={styles.filterIcon} /> Filters</button>
            <div>
              <img src={leftBtuIcon} style={{ marginRight: '5px', cursor: 'pointer', width: '28px', height: '28px' }} />
              <img src={leftBtuIcon} style={{ transform: 'rotate(180deg)', transition: 'transform 0.3s ease', cursor: 'pointer', width: '28px', height: '28px' }} />
            </div>
          </div>
        </div>
        {/* Filters using Flexbox */}
        {showFilters && (
          <div className={`tasksScreen-filters-container ${showFilters ? 'tasksScreen-open-filters' : ''}`}>
            <div className="tasksScreen-filters" style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Input
                label="Template Name"
                placeholder="Template Name"
                value={filterData?.templateName}
                onChange={(e) => handleInputChange('templateName', e.target.value)}
                searchBoxWidth={230}
              />
              <Dropdown
                ref={(el) => (dropdownRefs.current["Created By"] = el)}
                isOpen={openDropdown === "Created By"}
                toggleDropdown={() => toggleDropdown("Created By")}
                label="Created By"
                options={employeeList || []}
                value={filterData?.createdBy}
                loading={empLoading}
                errorMessage={empError}
                onChange={(value) => handleInputChange('createdBy', value?.value)}
                searchBoxWidth={230}
              />
              <div >
                <label style={{ fontSize: '12px', color: '#343C44' }}>Created Date</label>
                <DateInput
                  label="Created Date"
                  value={filterData?.createdDate}
                  onChange={(e) => handleInputChange('createdDate', e.target.value)}
                  width={'230px'}
                />
              </div>
            </div>
            <div>
              {filterSelectionError && <div className="list-error-msg" style={{ textAlign: 'left', paddingBottom: 5 }}> {filterSelectionError}</div>}
              <div className="tasksScreen-filter-buttons">
                <button
                  onClick={fetchEmailTemplateFilter}
                  className="tasksScreen-apply-button"
                  style={{ cursor: filterLoading ? 'not-allowed' : 'pointer', opacity: filterLoading ? 0.5 : 1 }} disabled={filterLoading}
                >
                  Apply
                </button>
                <button
                  onClick={cancelFilters}
                  className="tasksScreen-cancel-button"
                >
                  Cancel
                </button>
                <button
                  onClick={resetFilters}
                  className="tasksScreen-reset-button"
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        )}
      </div >

      <div className='basic-info-card' style={{ border: 'none', padding: '0px' }}>
        <div style={styles.tableWrapper}>
          <table className="tasksScreen-task-table">
            <thead>
              <tr>
                <th style={{ width: "10%" }}>Template Name</th>
                <th style={{ width: "70%" }}>Template Content</th>
                <th style={{ width: "10%" }}>Created Date</th>
                <th style={{ width: "10%" }}>Created By</th>
                {/* <th style={{ width: "15%" }}>Added By</th>
                <th style={{ width: "10%" }}>Opt Out</th>
                <th style={{ width: "5%" }}></th> */}
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "white" }}>
              {emailTemplateData?.map((category, index) => (
                <tr key={index}>
                  <td style={styles.tableValue}>{category?.template_name}</td>
                  <td style={styles.tableValue}>
                    {category?.template_text ? (
                      <>
                        <div
                          ref={(el) => (contentRefs.current[index] = el)}
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: expandedRows[`${index}-template_text`] ? "unset" : 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxHeight: expandedRows[`${index}-template_text`] ? "none" : "20px", // adjust based on font-size/line-height
                            lineHeight: "20px", // ensure consistent height for clamp
                            whiteSpace: "normal", // avoid forcing nowrap if using clamp
                          }}
                          dangerouslySetInnerHTML={{ __html: category?.template_text }}
                        />
                        {(showToggleMap[index] || expandedRows[`${index}-template_text`]) && (
                          <span
                            className="show-more-less"
                            onClick={() => toggleExpand(`${index}-template_text`)}
                            style={{ color: "#5A55D2", cursor: "pointer" }}
                          >
                            {expandedRows[`${index}-template_text`] ? "Less" : "More"}
                          </span>
                        )}
                      </>
                    ) : (
                      "--"
                    )}
                  </td>
                  <td style={styles.tableValue}>{convertGMTToLocal(category?.created_at, "dd/MM/yyyy")}</td>
                  <td style={styles.tableValue}>{category?.employee_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {filterLoading && <Loader loading={filterLoading} color={'var(--primary-loader-color)'} />}
        {filterError && <div className="list-error-msg">{filterError} </div>}
        {isModalOpen && (
          <ConfigurationAddTemplateModal isOpen={isModalOpen} onClose={handleCloseModal} channelType="email" refreshHandlers={refreshHandlers} />
        )}
      </div>
      <div className="tasksScreen-table-footer" >
        <span className="tasksScreen-pagination-info">
          {`${currentPage}-${totalPages} of items`}
        </span>
        <div className="tasksScreen-pagination">
          <button
            className="tasksScreen-pagination-button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1 || totalPages === 0}
          >
            <img
              src={downArrow}
              alt="Previous"
              className="tasksScreen-arrow-left tasksScreen-icon-image"
            />
          </button>
          {visiblePages.map((page) => (
            <button
              key={page}
              className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="tasksScreen-pagination-button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img
              src={downArrow}
              alt="Next"
              className="tasksScreen-arrow-right tasksScreen-icon-image"
            />
          </button>
        </div>
      </div>
      {/* <hr className="divider" style={{ marginTop: '20px' }} /> */}
    </>
  )

}

const styles = {
  categoryHeader: {
    color: '#1F384C',
    fontSize: 18,
    fontFamily: 'Roboto Slab',
    fontWeight: 500,
    paddingBottom: 20
  },
  tableWrapper: {
    overflowX: "auto", // Horizontal scroll
    whiteSpace: "nowrap", // Prevent table from wrapping on small devices
    // marginBottom:50
  },
  tableValue: {
    colour: '#192A3E',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px'
  },
  tableLink: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    textDecoration: 'underline',
    color: '#5A55D2'
  },
  container: {
    padding: "5px",
    backgroundColor: "#EFF0F4",
    border: "none",
    // borderRadius: "5px",
    border: '1px #EFF0F4 solid'
  },
  filtersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "15px",
  },
  filterButton: {
    backgroundColor: "white",
    color: "var(--button-bg-color)",
    border: "none",
    borderRadius: "5px",
    padding: "5px 8px",
    cursor: "pointer",
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    border: '1px var(--button-bg-color) solid'

  },
  filterIcon: {
    width: '10px',
    height: '10px',
    paddingRight: '5px'
  },

  paginationButtons: {
    display: "flex",
    gap: "5px",
  },
  paginationButton: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "5px 10px",
    cursor: "pointer",
  },
  filtersContainer: {
    // display: "flex",
    flexWrap: "wrap", // Wrap inputs to the next line if needed
    gap: "20px", // Space between inputs
    marginBottom: "15px",
    // justifyContent: "space-between", // Distribute inputs evenly
    border: '1px #EFF0F4 solid',
    padding: '10px'
  },
  buttonsContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  applyButton: {
    backgroundColor: "var(--button-bg-color)",
    color: "var(--button-text-color)",
    border: "none",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "transparent",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  resetButton: {
    backgroundColor: "transparent",
    color: "#555",
    border: "none",
    cursor: "pointer",
  },
  labaleStyle: {
    fontSize: '12px',
    // marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },


}

export default EmailTemplateList